export const Endpoints = {
  auth: {
    login: "/user/login",
    logout: "/user/logout",
    forgetpassword: "/user/forget-password",
    forgetpasswordVerify: "/user/verify-forget-password",
    resetpassword: "/user/reset-password",
    leaveReport: "/user/leave-report",
    getLeaveReport: "/reports/leaves",
    getMissionReport: "/reports/missions",
    getOvertimeReport: "/reports/more-work",
    getEmployeeActionReport: "/reports/employee-actions",
  },
  profile: { get: "/user/profile", edit: "/user/profile/edit" },
  applications: {
    forms: "/form/list",
    fill: "/request/create",
    editRequest: "/form/request/edit",
  },
  notifications: {
    list: "/user/notification/list",
    pushNotification: "/user/set-push-notification",
  },
  requests: {
    list: "/request/list",
    pendingActionList: "/request/pendingMyActionsList",
    accept: "/request/accept",
    reject: "/request/reject",
    cancel: "/request/cancel",
  },
  media: { upload: "/media/upload", get: "/media/get" },
  messages: {
    send: "/message/send",
    list: "/message/list",
    detail: "/message/detail",
  },
  dashboard: {
    overview: "/dashboard/overview",
  },
  employeeAction: {
    create: "/employee-action/create",
    list: "/employee-action/list",
    approve: "/employee-action/approve",
    reject: "/employee-action/reject",
  },
};

export const convertTag = (tag: string) => ({ id: tag, type: tag });
